/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useT as useTr, Autocomplete, TParams, tr } from 'talkr';
import en from '../../public/locales/en.json';

type Key = Autocomplete<typeof en>;

export const useT = () => {
	const { locale, languages, defaultLanguage } = useTr();
	return {
		T: (key: Key, params?: TParams) => tr({ locale, languages, defaultLanguage }, key, params),
	};
};
